module.exports = __webpack_public_path__ + "static/image/company/m/image_program.ver2_0_2.gif?03754588";